(function() {
       'use strict';

       angular.module('quantixApp').controller('userManualController',
    		   userManualController);

       userManualController.$inject = [ '$scope', '$http', '$window','$timeout', 'ClientListService','GenericServiceNew','RatingListService','PortfolioService','$sce'];

       function userManualController($scope, $http,$window, $timeout, ClientListService, GenericServiceNew, RatingListService,PortfolioService,$sce) {	
    	   var gridData='';
    		var vm = this;


			
			$scope.getUserManualList=function(){
				
				ClientListService.getUserManualList().then(
     					function(result) {
     						$scope.gridDataForUserManual = {
     								dataProvider : result,
     								delegate : $scope
     							};
     					});
     			
     		}
			
    	   
    	   $scope.userManualListGridCompletion = function (event) {
     		  gridData = event.target;
     		  gridData.validateNow();
          };
    	   

          
  		$scope.getUserManualData = function(item,col) {
   			if(item.template!=null){
   				return ('<div><a onClick=openUserManulDOC(this) id="'+ item.template    +'"' + '>' + item.moduleName + '</a></div>');
   			}else{
   				return ('<div><span>' + item.moduleName + '</span></div>');
   			}
   			
		}
    		
		$window.openUserManulDOC=function(item) {
			
			$scope.redirectToUserManulDOC(item)
	}

		$scope.alertForSFrating=true;
		$scope.responseData = null;
		
		$scope.redirectToUserManulDOC = function(item) {
			var fileName = item.id;
			$scope.fileNameForDownload= item.id;
			var type = '';
			var fd = new FormData();
			fd.append('fileName', fileName);
			var uploadUrl = 'api/adminScreen/showUserManualDocument';
			var filext = fileName.substring(fileName
					.lastIndexOf(".") + 1);
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				responseType : 'arraybuffer',
				headers : {
					'Content-Type' : undefined,
					 
				}
			}).success(
					function(response) {
						$scope.responseData = response;
						if (filext != '' && filext == 'pdf') {
							type = 'application/pdf'
						} else if (filext != '' && (filext == 'html' || filext == 'htm')) {
							type = 'text/html'
						} else if (filext == '' || filext == '-') {
							$scope.alertForSFrating=false;
						}
						var blob = new Blob([ response ], {
							type : type
						});
						
						var fileURL = (window.URL || window.webkitURL)
								.createObjectURL(blob);
						$scope.userManuContent = $sce
								.trustAsResourceUrl(fileURL);
						

						$('#SFdocumentPopUp').val("");
						$('#SFdocumentPopUp').modal({
							show : 'false'
						});
					}).error(function(response, status, headers, config) {

			});

		}

		$scope.downloadButtonClicked = function() {
			if ($scope.responseData) {
				downloadPdf($scope.responseData); 
			} else {
				console.error('No response data available.');
			}
		}

		function downloadPdf(response) {
			
			var blob = new Blob([response], { type: 'application/pdf' });
			var link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = $scope.fileNameForDownload;
			link.click();
		}

		
		
    	   
    		
    		$scope.getUserManualList();

       }


})();